import { SafeUrl } from "@angular/platform-browser";
import "./../util/ArrayExtensions";

// ********************************************************************************
// #region Classes
// ********************************************************************************

export class GlobalConstants
{
  public static altProductImagePath: string = "https://nf.aaoinfo.org/eweb/images/DEMO1/notavailable.jpg";
}

export interface Product {
  id: number;
  code: string;
  name: string;
  description: string;
  isDeleted: boolean;
  isActive: boolean;
  categoryId: number;
  categoryName: string;
  supplierId: number;
  supplierName: string;
  price: number;
  tax: number;
  priceString: string;
  alignersQuantity: number;
  hasDentalMonitoring: boolean;
  hasUnlimitedAligners: boolean;
  dentalMonitoringPrice: number;
  isCase: boolean;
  imagePath: string;
  images: any;
  specList: any;
  priceList: any;
  quantityStock: number;
  baseTax: number;
  basePriceProduct: number;
  basePriceExtraAligner: number;
  basePriceDentalMonitoring: number;
  basePriceComplexCase: number;
  productType: any;
  priceToShow: any;
  productPriceToShowWithDiscount:any
}

export interface ShoppingProduct {
  productId: number,
  productName: string,
  productImage: string,
  quantity: number,
  quantityExtraAligners: number,
  hasDentalMonitoring: boolean,
  priceDentalMonitoring: number,
  isComplexCase: boolean,
  subtotalProduct: number,
  subtotal: number,
  baseTax: number,
  basePriceProduct: number,
  basePriceExtraAligner: number,
  basePriceDentalMonitoring: number,
  caseId?: number
}

export interface ShoppingService {
  serviceName: string;
  serviceCount: number;
  serviceUnitPrice: number;
  serviceTotal: number;
  serviceImage: string;
  serviceNewSetup: number;
  serviceProductUpgrade: any;
}

export interface IEntity
{
  id: number;
}

export class LocalStorage implements Storage
{
  [name: string]: any;
  readonly length: number;
  clear(): void { }
  getItem(key: string): string | null { return undefined; }
  key(index: number): string | null { return undefined; }
  removeItem(key: string): void { }
  setItem(key: string, value: string): void { }
}

export class UserDto
{

}

export class LoginDto
{
  id: string = "";
  password: string = "";
  cartId: string = "";
  language: string = "";
}

export class RefreshTokenDto
{
  language: string = "";
  refreshToken: string = "";
}

export class ValidateSessionDto
{
  language: string = "";
  token: string = "";
}

// #endregion Classes

// ********************************************************************************
// #region Interfaces
// ********************************************************************************

export interface IEntity
{
  id: number;
}

export interface IBaseRequest
{
  token: string;
}

//Add base interfaces
export interface FileHandle {
  file: File,
  url: SafeUrl
}

export interface UserAccess {
  email: string,
  password: string
}

export interface UserAccessResetPassword {
  newPassword: string,
  confirmPassword: string
}

export interface UserSignUpSpecialist {
  name: string,
  firstLastName: string,
  secondLastName: string,
  hasSpecialty: string,
  professionalLicense: string,
  email: string,

  officeName: string,
  contactPerson: string,
  country: string,
  state: string,
  phone: number,
  street: string,
  streetNumber: number,
  city: string,
  zipcode: number,
  website: string,
  socialMedia: string,
}

export interface UserSignUpResident {
  name: string,
  firstLastName: string,
  secondLastName: string,
  hasSpecialty: string,
  graduationYear: number,
  graduationMonth: number,
  email: string,

  officeName: string,
  contactPerson: string,
  country: string,
  state: string,
  phone: number,
  street: string,
  streetNumber: number,
  city: string,
  zipcode: number,
  website: string,
  socialMedia: string,
}

// #endregion Interfaces


// Enums
export enum FileApplicationType
{
  PDF = 'application/pdf',
  STL = 'application/octet-stream',
  TXT = 'application/plain',
  ZIP7 = 'application/x-7z-compressed',
  ZIP = 'application/zip',
  RAR = 'application/x-rar-compressed',
  WORD = 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  POWERPOINT = 'application/vnd.openxmlformats-officedocument.presentationml.presentation',
  EXCEL = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
}

export enum ImageType
{
  JPG = 'image/jpg',
  JPEG = 'image/jpeg',
  PNG = 'image/png',
  GIF = 'image/gif',
  TIF = 'image/tiff',
  BMP = 'image/bmp'
}

export enum VideoType
{
  MP4 = 'video/mp4',
  QUICKTIME = 'video/quicktime',
  MOV = 'video/mov',
  MPG = 'video/mpg',
  MPEG = 'video/mpeg',
  MPEG4 = 'video/mpeg4',
}


export enum FileExtension//Agregar nuevos formatos de archivo
{
  PDF = '.pdf',
  TXT = '.txt',
  ZIP = '.zip',
  ZIP7 = '.7z',
  RAR = '.rar',
  WORD = '.docx',//
  POWERPOINT = '.pptx',//
  EXCEL = '.xlsx',//
}

export enum FileWeirdExtension
{
  STL = '.stl',
}

export enum ImageExtension
{
  JPG = '.jpg',
  JPEG = '.jpg',
  PNG = '.png',
  GIF = '.gif',
  TIF = '.tif',
  BMP = '.bmp'
}

export enum Section
{
  Backoffice = 1,
  Ecommerce = 2
}

export enum PasswordValidationType
{
  AtLeastOneNumber = '[0-9]{1}',
  AtLeastOneCapital = '[A-Z]{1}',
  AtLeastOneSpecial = '[#$%&?!\\¡\\¿\\`\\@\\^\\*\\(\\)\\_\\+\\-\\=\\[\\]\\{\\}\\;\'\\:\\"\\|\\,\\.\\<\\>\\/\\~\\u005C]{1}',
  NoConsecutive = '^(?!.*(abc|ABC|123)+).*$',
  NoKeyboardSequences = '^(?!.*(qwerty|QWERTY|ASDFG|asdfg)+).*$',
  MinLength = '[A-Z0-9a-z#$%&?!\\¡\\¿\\`\\@\\^\\*\\(\\)\\_\\+\\-\\=\\[\\]\\{\\}\\;\'\\:\\"\\|\\,\\.\\<\\>\\/\\~\\u005C]{8,}$',
}

export enum PaymentType
{
  Unasigned =0,
  OpenPay = 1,
  PayNet = 2,
  SPEI = 3,
  InPerson = 5,
  PayLink = 6,
  Courtesy = 7,
  CardPay = 8,
  CourtesyEvents = 9,
  CourtesyHexagon = 10,
  CourtesyWarranty = 11
}

export enum PaymentPlan
{
  SinglePayment = 1,
  TwoMonths = 3,
  SixMonths = 6,
  NineMonths = 9,
  TwelveMonths = 12,
}

export const PaymentTypeLabel = new Map<PaymentType, string>([
  [PaymentType.Unasigned, "Forma de pago pendiente"],
  [PaymentType.OpenPay, "OpenPay"],
  [PaymentType.PayNet, "PayNet"],
  [PaymentType.SPEI, "SPEI"],
  [PaymentType.InPerson, "InPerson"],
  [PaymentType.PayLink, "PayLink"],
  [PaymentType.Courtesy, "Cortesía Comercial"],
  [PaymentType.CardPay, "Pago con terminal"],
  [PaymentType.CourtesyEvents, "Cortesía Eventos"],
  [PaymentType.CourtesyHexagon, "Cortesía Hexagon"],
  [PaymentType.CourtesyWarranty, "Cortesía Garantía"]
]);

export const PaymentTypeDescription = new Map<PaymentType, string>([
  [PaymentType.Unasigned, "Forma de pago pendiente"],
  [PaymentType.OpenPay, "Pago con Tarjeta"],
  [PaymentType.PayNet, "Pago en Establecimientos"],
  [PaymentType.SPEI, "Pago por Transferencia"],
  [PaymentType.InPerson, "Pago presencial"],
  [PaymentType.PayLink, "Pago por Link de pago"],
  [PaymentType.Courtesy, "Cortesía Comercial"],
  [PaymentType.CardPay, "Pago con terminal"],
  [PaymentType.CourtesyEvents, "Cortesía Eventos"],
  [PaymentType.CourtesyHexagon, "Cortesía Hexagon"],
  [PaymentType.CourtesyWarranty, "Cortesía Garantía"]
]);

export const PaymentPlanDescription = new Map<PaymentPlan, string>([
  [PaymentPlan.SinglePayment, "De contado"],
  [PaymentPlan.TwoMonths, "Financiamiento a 3 meses"],
  [PaymentPlan.SixMonths, "Financiamiento a 6 meses"],
  [PaymentPlan.NineMonths, "Financiamiento a 9 meses"],
  [PaymentPlan.TwelveMonths, "Financiamiento a 12 meses"],
]);

export const PaymentMethodsArray: any[] = [
  {"key": 1, "value": "01: Efectivo"},
  {"key": 2, "value": "02: Cheque nominativo"},
  {"key": 3, "value": "03: Transferencia electrónica de fondos"},
  {"key": 4, "value": "04: Tarjeta de crédito"},
  {"key": 28, "value": "28: Tarjeta de débito"},
  {"key": 31, "value": "31: Intermediario pagos"},
  {"key": 99, "value": "99: Por definir"},
];


export enum ShowInSection
{
  None = 0,
  Backoffice = 1,
  Ecommerce = 2,
  Both=3
}

export const PaymentTypeArray: any[] = [
  {
    type: PaymentType.Unasigned,
    label: PaymentTypeLabel.get(PaymentType.Unasigned),
    description: PaymentTypeDescription.get(PaymentType.Unasigned),
    image: "https://aliwellstorageaccount.blob.core.windows.net/uploads/website-files/body/openpay.png",
    showIn: ShowInSection.None
  },
  {
    type: PaymentType.OpenPay,
    label: "Tarjeta de crédito o débito",
    description: "Pago seguro e inmediato",
    image: "https://aliwellstorageaccount.blob.core.windows.net/uploads/website-files/body/visa.png",
    showIn: ShowInSection.Ecommerce,
    isPrimary: true,
    logos: [
      "https://aliwellstorageaccount.blob.core.windows.net/uploads/website-files/body/visa.png",
      "https://aliwellstorageaccount.blob.core.windows.net/uploads/website-files/body/masterCard.png",
      "https://aliwellstorageaccount.blob.core.windows.net/uploads/website-files/body/americanExpress.png",
      "https://aliwellstorageaccount.blob.core.windows.net/uploads/website-files/body/carnet.png",
    ]
  },
  {
    type: PaymentType.PayNet,
    label: PaymentTypeLabel.get(PaymentType.PayNet),
    description: PaymentTypeDescription.get(PaymentType.PayNet),
    image: "https://aliwellstorageaccount.blob.core.windows.net/uploads/website-files/body/paynet.png",
    showIn: ShowInSection.Backoffice
  },
  {
    type: PaymentType.SPEI,
    label: "Transferencia",
    description: "SPEI bancario",
    image: "https://aliwellstorageaccount.blob.core.windows.net/uploads/website-files/body/spei_crop.png",
    showIn: ShowInSection.Both,
    isPrimary: false
  },
  {
    type: PaymentType.InPerson,
    label: PaymentTypeLabel.get(PaymentType.InPerson),
    description: PaymentTypeDescription.get(PaymentType.InPerson),
    image: "",
    showIn: ShowInSection.Backoffice
  },
  {
    type: PaymentType.PayLink,
    label: "Link de pago",
    description: "Te enviamos el link",
    image: "https://aliwellstorageaccount.blob.core.windows.net/uploads/website-files/body/Link%20de%20Pago.svg",
    showIn: ShowInSection.Both,
    isPrimary: false
  },
  {
    type: PaymentType.Courtesy,
    label: PaymentTypeLabel.get(PaymentType.Courtesy),
    description: PaymentTypeDescription.get(PaymentType.Courtesy),
    image: "",
    showIn: ShowInSection.Backoffice
  },
  {
    type: PaymentType.CardPay,
    label: PaymentTypeLabel.get(PaymentType.CardPay),
    description: PaymentTypeDescription.get(PaymentType.CardPay),
    image: "https://aliwellstorageaccount.blob.core.windows.net/uploads/website-files/body/Pago%20en%20Sucursal.svg",
    showIn: ShowInSection.Backoffice
  },
  {
    type: PaymentType.CourtesyEvents,
    label: PaymentTypeLabel.get(PaymentType.CourtesyEvents),
    description: PaymentTypeDescription.get(PaymentType.CourtesyEvents),
    image: "",
    showIn: ShowInSection.Backoffice
  },
  {
    type: PaymentType.CourtesyHexagon,
    label: PaymentTypeLabel.get(PaymentType.CourtesyHexagon),
    description: PaymentTypeDescription.get(PaymentType.CourtesyHexagon),
    image: "",
    showIn: ShowInSection.Backoffice
  },
  {
    type: PaymentType.CourtesyWarranty,
    label: PaymentTypeLabel.get(PaymentType.CourtesyWarranty),
    description: PaymentTypeDescription.get(PaymentType.CourtesyWarranty),
    image: "",
    showIn: ShowInSection.Backoffice
  },
];

export const PasswordErrorMessage = new Map<PasswordValidationType, string>([
  [PasswordValidationType.AtLeastOneNumber, "La contraseña debe tener al menos 1 número"],
  [PasswordValidationType.AtLeastOneCapital, "La contraseña debe tener al menos 1 mayúscula"],
  [PasswordValidationType.AtLeastOneSpecial, 'La contraseña debe tener al menos 1 carácter especial'],
  [PasswordValidationType.NoConsecutive, 'No debe contener letras o numeros consecutivos. (abc, 123)'],
  [PasswordValidationType.NoKeyboardSequences, 'No debe contener secuencias del teclado(qwerty, asdfg)'],
  [PasswordValidationType.MinLength, 'La contraseña debe tener al menos 8 caracteres'],
]);

export const SmartSTLRequestStatuses = new Map<string, string>([
  ["Incompleto", "submission_incomplete"],
  ["Espera de STL", "waiting_for_stl_files"],
  ["Espera de nuevo STL", "waiting_for_new_stl_files"],
  ["Espera de escaneo Px", "waiting_for_patient_scan"],
  ["Espera de nuevo escaneo Px", "waiting_for_new_patient_scan"],
  ["Revisión", "order_review"],
  ["Rechazado", "order_rejected"],
  ["Rechazado: el paciente tiene brackets", "order_rejected_braces_treatment"],
  ["Rechazado: el paciente utiliza un aparato Carriere", "order_rejected_carriere_treatment"],
  ["Rechazado: el paciente usa un expansor palatino", "order_rejected_palatal_expander"],
  ["Rechazado: erupción de nuevos dientes desde el último escaneo intraoral", "order_rejected_additional_teeth"],
  ["Rechazado: cambios anatómicos significativos (cambios en la forma del diente por restauraciones, dentición mixta, accidente, cirugía u otra causa)", "order_rejected_anatomical_changes"],
  ["Rechazado: otra razón no especificada", "order_rejected_other"],
  ["En proceso de cancelación", "in_cancelation_proccess"],
  ["Cancelado: la orden fue cancelada", "order_cancelled"],
  ["Smart STL disponible", "smart_stl_available"],
]);

export const SmartSTLTreatmentContext = new Map<string, string>([
  ["Nueva Etapa (MC)", "mid_course"],
  ["Nueva Etapa (D)", "refinement"],
]);

export const SmartSTLAccessoriesAndButtonsArray: any[] = [
  {
    order: 0,
    key:"Px no tiene accesorios ni botones",
    value:"non_assessed"
  },
  {
    order: 1,
    key:"Conservar todo",
    value:"keep_all"
  },
  {
    order: 2,
    key:"Eliminar todo",
    value:"remove_all"
  }
];
export enum LegacyStatusRanges{
  setup = 1,
  manufactura = 2,
};
